import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Köszönjük a szavazatodat! ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" További szavazások ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_advertising = _resolveComponent("advertising")!
  const _component_headline = _resolveComponent("headline")!
  const _component_cta_button = _resolveComponent("cta-button")!
  const _component_separator = _resolveComponent("separator")!
  const _component_container = _resolveComponent("container")!
  const _component_renderer = _resolveComponent("renderer")!
  const _component_page = _resolveComponent("page")!

  return (_ctx.user && _ctx.vote)
    ? (_openBlock(), _createBlock(_component_page, {
        key: 0,
        is: "section",
        class: "vote-thanks-page",
        "has-banner": true
      }, {
        default: _withCtx(() => [
          (_ctx.vote.form.advertising)
            ? (_openBlock(), _createBlock(_component_advertising, {
                key: 0,
                type: "overlay",
                code: _ctx.vote.form.advertising.code,
                image: _ctx.vote.form.advertising.image,
                link: _ctx.vote.form.advertising.link
              }, null, 8, ["code", "image", "link"]))
            : _createCommentVNode("", true),
          _createVNode(_component_container, { class: "vote-thanks-page__container" }, {
            default: _withCtx(() => [
              _createVNode(_component_headline, { size: "medium" }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_cta_button, {
                theme: "primary",
                to: { name: 'vote-list' }
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _hoisted_3,
              _hoisted_4,
              _hoisted_5,
              _createVNode(_component_separator)
            ]),
            _: 1
          }),
          _createVNode(_component_container, { type: "section" }, {
            default: _withCtx(() => [
              _createVNode(_component_renderer, { template: _ctx.contentHtml }, null, 8, ["template"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}